/**
 * Created by Alex Aguilar on 7/29/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('structureSeatMapsController', structureSeatMapsController)
        .controller('newEditStructureSeatMapController', newEditStructureSeatMapController)
        .controller('editSeatNameController', editSeatNameController)
        .controller('deleteCabinSeatController', deleteCabinSeatController)
        .controller('deleteStructureSeatMapController', deleteStructureSeatMapController);

    structureSeatMapsController.$inject = ['tabs', 'structures', 'linkService'];
    newEditStructureSeatMapController.$inject = ['tabs', 'loadForm', 'action', 'tabService', '$uibModal', 'toastr', '$translate',
        'structureSeatMapService', 'seatModelAircraftService', 'linkService', 'legendService'];
    editSeatNameController.$inject = ['index', 'cabinIndex', 'formSeatMap', 'seatProperties', 'seatModelAircrafts',
        'seatModelAircraftService', 'linkService', '$uibModalInstance'];
    deleteCabinSeatController.$inject = ['index', 'cabinIndex', 'formSeatMap', '$uibModalInstance'];
    deleteStructureSeatMapController.$inject = ['structureId', 'structure', 'structureSeatMapService', '$uibModalInstance'];

    function structureSeatMapsController(tabs, structures, linkService) {
        var vm = this;
        vm.tabs = tabs;
        vm.pages = [];
        vm.structures = (structures.data._embedded) ? structures.data._embedded.structures : [];
        vm.linkService = linkService;
        vm.pages = structures.data.page;
    }

    function newEditStructureSeatMapController(tabs, loadForm, action, tabService, $uibModal, toastr, $translate,
                                               structureSeatMapService, seatModelAircraftService, linkService, legendService) {
        var vm = this;
        vm.loadForm = loadForm.data._embeddeds;
        vm.tabs = tabs;
        vm.action = action;
        vm.widthStep = 100 / 3;

        vm.structure = (vm.loadForm.structure) ? vm.loadForm.structure : null;
        vm.modelAircrafts = (vm.loadForm.modelAircrafts) ? vm.loadForm.modelAircrafts : [];
        vm.cabinCategories = tabService.getCabinCategories();
        vm.lengends = (vm.loadForm.legends) ? vm.loadForm.legends : [];
        vm.seatProperties = (vm.loadForm.seatProperties) ? vm.loadForm.seatProperties : [];
        vm.seatModelAircrafts = (vm.loadForm.seatModelAircrafts) ? vm.loadForm.seatModelAircrafts : [];
        vm.seatsNotDefault = seatModelAircraftService.getSeatsByNotDefault(vm.seatModelAircrafts, 'F', 'B', 'Y');

        vm.view = false;
        vm.cabinSeatsView = {};
        vm.formSeatMap = structureSeatMapService.getObjectFormStructure();

        vm.numRows = structureSeatMapService.getNumberRowsColumns();
        vm.numColumns = structureSeatMapService.getNumberColumns();

        vm.updateTotalWidthSeatMap = function () {
            vm.formSeatMap.totalWidths = calculateTotalPixels(vm.formSeatMap.widths, 'width');
            vm.formSeatMap.totalHeights = calculateTotalPixels(vm.formSeatMap.heights, 'height');
            vm.formSeatMap.columnMax = calculateColumnMax(vm.formSeatMap.rows);
            vm.formSeatMap.rowMax = calculateDetailRowMax(vm.formSeatMap.detailRows, 1);
            vm.formSeatMap.totalWidthSeatMap = vm.formSeatMap.totalWidthSeatMap + vm.formSeatMap.totalWidths;
        }

        vm.updateHeightCabins = function () {
            var heightMax = calculateNumMax(vm.formSeatMap.heights);
            angular.forEach(vm.formSeatMap.cabins, function (cabin) {
                cabin.height = heightMax;
            });
        }

        vm.reCalculateHeightCabins = function () {
            vm.formSeatMap.heights = [];
            vm.formSeatMap.detailRows = [];
            angular.forEach(vm.formSeatMap.cabins, function (cabin) {
                var cabinClass = null;
                if(cabin.category === 'Y') {
                    cabinClass = structureSeatMapService.getCabinClassSeatOption('economyClass');
                } else if(cabin.category === 'C'){
                    cabinClass = structureSeatMapService.getCabinClassSeatOption('businessClass');
                } else if(cabin.category === 'F'){
                    cabinClass = structureSeatMapService.getCabinClassSeatOption('firstClass');
                }
                cabin.height = cabinClass.height * cabin.row;
                vm.formSeatMap.heights.push(cabin.height);
                vm.formSeatMap.detailRows.push({category: cabin.category, row: cabin.row, width: cabin.width, height: cabin.height});
            });
        }

        if (vm.action !== 'new') {
            vm.formSeatMap.modelAircraft = vm.structure._embedded.modelAircraft;
            vm.formSeatMap.name = vm.structure.name;
            vm.formSeatMap.twoFloors = vm.structure.twoFloors;
            vm.formSeatMap.cabins = getCabins(vm.structure._embedded.cabins, linkService);
            vm.reCalculateHeightCabins();
            vm.formSeatMap.cabinMain.legends = getLegends(vm.structure._embedded.structureLegends, vm.structure.twoFloors, linkService);
            addColumns(vm.formSeatMap.cabins, vm);
            vm.updateTotalWidthSeatMap();
            vm.updateHeightCabins();
            vm.view = true;
            vm.cabinSeatsView = vm.formSeatMap.cabins[0];
        }
        vm.old = angular.copy(vm.formSeatMap);

        vm.addCabin = function () {
            vm.formSeatMap.cabins.push({
                category: "",
                categoryCode: null,
                row: 3,
                column: 3,
                rowNum: 3,
                columnNum: 3,
                width: 0,
                height: 0,
                view: false,
                floor: false,
                name: 'string',
                seats: []
            });
        }

        vm.handleBlurColumn = function (index) {
            var auxColumn = vm.formSeatMap.cabins[index].column;
            if (auxColumn === undefined) {
                vm.formSeatMap.cabins[index].column = 3;
            } else if (auxColumn === 0) {
                vm.formSeatMap.cabins[index].column = 3;
            } else if (auxColumn < 0) {
                vm.formSeatMap.cabins[index].column = 3;
            }
        }

        vm.isGenerateDisabled = function (cabin) {

        }

        vm.generateCabin = function (index) {
            var cabin = vm.formSeatMap.cabins[index];
            var rows = cabin.rowNum;
            var columns = cabin.columnNum;
            var seatOptions = structureSeatMapService.getSeatOptions();

            cabin.row = rows;
            cabin.column = columns;

            vm.formSeatMap.totalWidthSeatMap = 1300;
            cabin.floor = (vm.formSeatMap.twoFloors) ? 2 : 1;

            if(cabin.categoryCode !== '' && rows !== ''&& columns !== '') {
                cabin.category = cabin.categoryCode;
                var seatModelAircraft = seatModelAircraftService.getSeatModelAircraftByOne(vm.seatModelAircrafts, true, cabin.category);
                if (rows <= 12) {
                    var cabinClass = {};

                    switch (cabin.category) {
                        case "F":
                            cabinClass = seatOptions.firstClass;
                            break;
                        case "C":
                            cabinClass = seatOptions.businessClass;
                            break;
                        case "Y":
                            cabinClass = seatOptions.economyClass;
                            break;
                    }


                    vm.view = true;
                    vm.formSeatMap.cabins[index].seats = [];

                    var top = 0;
                    var posHeaderNames = rows - 1;
                    for (var i = 0; i < rows; i++) {
                        var left = 20;
                        var numberHeader = 1;
                        for (var j = 0; j < columns; j++) {
                            var headerSeat = (j === 0) ? true : false;
                            var headerSeatName = (j === 0) ? cabinClass.headerSeatName[posHeaderNames] : "";
                            vm.formSeatMap.cabins[index].seats.push({
                                'left': left,
                                'top': top,
                                'width': cabinClass.width,
                                'height': cabinClass.height,
                                'number': cabinClass.headerSeatName[posHeaderNames] + numberHeader,
                                'seatModelAircraftId': parseInt(linkService.getLinkId(seatModelAircraft._links.self.href)),
                                'seatPropertyId': [],
                                'seatDoubleFaceMask': '',
                                'headerSeat': headerSeat,
                                'headerSeatName': headerSeatName,
                                'aisle': false,
                                'urlImage': seatModelAircraft.url
                            });
                            left = left + cabinClass.width + cabinClass.spaceBetweenSeat;
                            numberHeader++;
                        }
                        top = top + cabinClass.height;
                        posHeaderNames--;
                    }

                    vm.cabinSeatsView = vm.formSeatMap.cabins[index];
                    vm.lastCabinSeat = vm.cabinSeatsView.seats[vm.cabinSeatsView.seats.length - 1];
                    vm.formSeatMap.cabins[index].width = vm.lastCabinSeat.left + cabinClass.width;
                    vm.formSeatMap.cabins[index].height = vm.lastCabinSeat.top + cabinClass.height;

                    vm.reCalculateHeightCabins();
                    addColumns(vm.formSeatMap.cabins, vm);
                    vm.updateTotalWidthSeatMap();
                    vm.updateHeightCabins();

                    changeCabinView(vm.formSeatMap.cabins, index, vm);
                } else {
                    toastr.error($translate.instant('SEAT_MAP.ERROR_CABIN'));
                }
            }
        }

        vm.viewCabin = function (index) {
            changeCabinView(vm.formSeatMap.cabins, index, vm);
            vm.cabinSeatsView = vm.formSeatMap.cabins[index];
        }

        vm.deleteCabin = function (index) {
            vm.formSeatMap.rows.splice(index, 1);
            vm.formSeatMap.widths.splice(index, 1);
            vm.formSeatMap.heights.splice(index, 1);
            vm.formSeatMap.cabins.splice(index, 1);

            vm.viewCabin(vm.formSeatMap.cabins.length - 1);

            vm.updateTotalWidthSeatMap();
        }

        vm.reGenerateCabin = function (cabinIndex, aisleIndex) {
            var cabin = vm.formSeatMap.cabins[cabinIndex];
            var rows = cabin.row;
            var columns = cabin.column;
            var indexSeat = 0;
            var aux = 0;
            for (var i = 0; i < rows; i++) {
                for (var j = 0; j < columns; j++) {
                    if (aisleIndex == aux) {
                        vm.formSeatMap.cabins[cabinIndex].seats[indexSeat].aisle = true;
                    }
                    indexSeat++;
                }
                aux = indexSeat;
            }
        }

        vm.reGenerateCabinNames = function (cabinIndex, aisleIndex, latter) {
            var cabin = vm.formSeatMap.cabins[cabinIndex];
            var rows = cabin.row;
            var columns = cabin.column;
            var indexSeat = 0;
            var aux = 0;
            for (var i = 0; i < rows; i++) {
                var numberHeader = 1;
                for (var j = 0; j < columns; j++) {
                    var headerSeatName = (j === 0) ? latter : "";
                    if (aisleIndex === aux) {
                        vm.formSeatMap.cabins[cabinIndex].seats[indexSeat].headerSeatName = headerSeatName;
                        vm.formSeatMap.cabins[cabinIndex].seats[indexSeat].number = latter + numberHeader;
                    }
                    indexSeat++;
                    numberHeader++;
                }
                aux = indexSeat;
            }
        }

        vm.editSeatName = function (indexSeat, indexCabin, header) {
            var templateNameHtml = (header === true) ? 'editHeaderSeatName.html' : 'editSeatName.html';
            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/configGeneral/aircraft/structureSeatMap/' + templateNameHtml,
                controller: 'editSeatNameController',
                controllerAs: 'vm',
                size: 'md',
                close: true,
                resolve: {
                    'index': [function () {
                        return indexSeat;
                    }],
                    'cabinIndex': [function () {
                        return indexCabin;
                    }],
                    'formSeatMap': [function () {
                        return vm.formSeatMap;
                    }],
                    'header': [function () {
                        return header;
                    }],
                    'seatProperties': [function () {
                        return vm.seatProperties;
                    }],
                    'seatModelAircrafts': [function () {
                        return vm.seatModelAircrafts;
                    }]
                }
            });

            modalInstance.result.then(function (response) {//formHeaderSeat
                vm.formSeatMap.cabins[indexCabin].seats[indexSeat].headerSeatName = (!response.form.aisle) ? response.form.seatName : '';
                vm.formSeatMap.cabins[indexCabin].seats[indexSeat].aisle = response.form.aisle;
                vm.formSeatMap.cabins[indexCabin].seats[indexSeat].number = response.form.seatNumber;
                vm.formSeatMap.cabins[indexCabin].seats[indexSeat].seatPropertyId = arrayStringToInteger(response.seatPropertyIds);
                vm.formSeatMap.cabins[indexCabin].seats[indexSeat].seatDoubleFaceMask = updateSeatDoubleFaceMask(vm.seatProperties, response.seatPropertyIds, linkService);

                if (response.form.aisle) {
                    vm.reGenerateCabin(indexCabin, indexSeat, response.form.flagLetter);
                } else {
                    if (response.form.flagLetter) {
                        vm.reGenerateCabinNames(indexCabin, indexSeat, response.form.seatName);
                    }
                }
            }, function () {
            });

        }

        vm.deleteSeat = function (index, cabinIndex) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/configGeneral/aircraft/structureSeatMap/deleteCabinSeat.html',
                controller: 'deleteCabinSeatController',
                controllerAs: 'vm',
                size: 'md',
                close: true,
                resolve: {
                    'index': [function () {
                        return index;
                    }],
                    'cabinIndex': [function () {
                        return cabinIndex;
                    }],
                    'formSeatMap': [function () {
                        return vm.formSeatMap;
                    }]
                }
            });

            modalInstance.result.then(function () {
                vm.formSeatMap.cabins[cabinIndex].seats.splice(index, 1);
            }, function () {
            });
        }

        vm.addCabinLegend = function (legend) {
            if (legend.name === 'right-wing') {
                var isRightWing = legendService.thereLegendByName(vm.formSeatMap.cabinMain.legends, 'right-wing');
                if (!isRightWing) {
                    vm.addLegend(legend);
                }
            }

            if (legend.name === 'left-wing') {
                var isLeftWing = legendService.thereLegendByName(vm.formSeatMap.cabinMain.legends, 'left-wing');
                if (!isLeftWing) {
                    vm.addLegend(legend);
                }
            }

            if (legend.name !== 'right-wing' && legend.name !== 'left-wing') {
                vm.addLegend(legend);
            }
        }

        vm.addLegend = function (legend) {
            vm.formSeatMap.cabinMain.legends.push({
                legendId: parseInt(linkService.getLinkId(legend._links.self.href)),
                structureLegendId: 0,
                left: 0,
                top: 0,
                width: 50,
                height: 50,
                nameLegend: legend.name,
                floor: (vm.formSeatMap.twoFloors) ? 2 : 1,
                position: 'relative'
            });
        }

        vm.deleteCabinLegend = function (legend, legendIndex) {
            vm.formSeatMap.cabinMain.legends.splice(legendIndex, 1);
        }

        vm.updateCabinLegend = function (index, legend) {
            vm.formSeatMap.cabinMain.legends[index].left = legend.left;
            vm.formSeatMap.cabinMain.legends[index].top = legend.top;
            vm.formSeatMap.cabinMain.legends[index].width = legend.width;
            vm.formSeatMap.cabinMain.legends[index].height = legend.height;
        }

        vm.updateSeat = function (indexSeat, indexCabin, seat) {
            vm.formSeatMap.cabins[indexCabin].seats[indexSeat].left = seat.left;
            vm.formSeatMap.cabins[indexCabin].seats[indexSeat].top = seat.top;
        }

        vm.validateSeatMapWizard = function (isValid, type) {
            if (isValid) {
                if (type === "step3") {
                    var structure = {
                        cabins: vm.formSeatMap.cabins,
                        modelAircraftId: vm.formSeatMap.modelAircraft.modelAircraftId,
                        name: vm.formSeatMap.name,
                        rbcStructureLegends: vm.formSeatMap.cabinMain.legends,
                        twoFloors: false
                    }
                    if (vm.formSeatMap.cabinMain.legends.length > 0) {
                        if (vm.action === 'new') {
                            structureSeatMapService.saveStructure(structure);
                        } else {
                            if(change()){
                                toastr.error($translate.instant('air.structureSeatMap.withoutChanges'));
                            }else{
                                structureSeatMapService.updateStructure(structure, vm.structure.structureId);
                            }

                        }

                    } else {
                        toastr.error($translate.instant('air.structureSeatMap.noteLegends'));
                    }
                }
            }
        }

        vm.isValidForm = function (isValid) {
            return isValid;
        }

        function getCabins(cabins, linkService) {
            var arrayCabins = [];
            angular.forEach(cabins, function (cabin, indexCabin) {
                arrayCabins.push({
                    category: cabin.category,
                    categoryCode: cabin.category,
                    name: cabin.name,
                    row: cabin.row,
                    column: cabin.column,
                    rowNum: cabin.row,
                    columnNum: cabin.column,
                    floor: cabin.floor,
                    width: cabin.width,
                    height: cabin.height,
                    left: cabin.left,
                    top: cabin.top,
                    view: (indexCabin == 0) ? true : false,
                    seats: getCabinSeats(cabin._embedded.seatPositions, linkService)
                });
            });
            return arrayCabins;
        }

        function getCabinSeats(seats, linkService) {
            var arraySeats = [];
            angular.forEach(seats, function (seat) {
                arraySeats.push({
                    left: seat.left,
                    top: seat.top,
                    width: seat.width,
                    height: seat.height,
                    number: seat.number,
                    seatModelAircraftId: parseInt(seat._embedded.seatModelAircraft.seatModelAircraftId),
                    seatPropertyId: getSeatProperties(seat._embedded.seatProperties, linkService),
                    seatDoubleFaceMask: (seat._embedded.seatProperties) ? getSeatDoubleFaceMask(seat._embedded.seatProperties): '',
                    headerSeat: seat.headerSeat,
                    headerSeatName: seat.headerSeatName,
                    aisle: seat.aisle,
                    urlImage: seat._embedded.seatModelAircraft.url
                })
            });
            return arraySeats;
        }

        function getSeatProperties(seatProperties, linkService) {
            var arraySeatProperties = [];
            angular.forEach(seatProperties, function (seatProperty) {
                arraySeatProperties.push(parseInt(linkService.getLinkId(seatProperty._links.self.href)));
            });
            return arraySeatProperties;
        }

        function getSeatDoubleFaceMask(seatProperties) {
            var doubleFaceMask = '';
            if (seatProperties.length > 0) {
                doubleFaceMask = 'seat-double-face-mask';
            }
           return doubleFaceMask;
        }

        function updateSeatDoubleFaceMask(seatProperties, seatPropertiesIds, linkService) {
            var doubleFaceMask = '';
            for (var i = 0; i < seatProperties.length; i++) {
                for (var j = 0; j < seatPropertiesIds.length; j++) {
                    if (seatPropertiesIds[j] === linkService.getLinkId(seatProperties[i]._links.self.href)) {
                        doubleFaceMask = 'seat-double-face-mask';
                        break;
                    }
                }
            }
            return doubleFaceMask;
        }

        function getLegends(legends, twoFloors, linkService) {
            var arrayLegends = [];
            angular.forEach(legends, function (legend) {
                arrayLegends.push({
                    legendId: parseInt(linkService.getLinkId(legend._embedded.legend._links.self.href)),
                    structureLegendId: 0,
                    left: legend.left,
                    top: legend.top,
                    width: legend.width,
                    height: legend.height,
                    nameLegend: legend.nameLegend,
                    floor: (twoFloors) ? 2 : 1,
                    position: 'relative'
                });

            });
            return arrayLegends;
        }

        function change(){
            /*var res = true;
            if(vm.formSeatMap.modelAircraft != undefined && vm.formSeatMap.modelAircraft.name==vm.old.modelAircraft.name &&
                vm.formSeatMap.name == vm.old.name && vm.formSeatMap.cabins.length==vm.old.cabins.length){
                for(var i=0; i<vm.formSeatMap.cabins.length; i++){
                    if(!(vm.formSeatMap.cabins[i].row == vm.old.cabins[i].row &&
                        vm.formSeatMap.cabins[i].column == vm.old.cabins[i].column &&
                        vm.formSeatMap.cabins[i].seats.length == vm.old.cabins[i].seats.length)){
                        res = false;
                        break
                    }
                }
            }else{
                res = false;
            }*/
            return false;
        }
    }

    function editSeatNameController(index, cabinIndex, formSeatMap, seatProperties, seatModelAircrafts, seatModelAircraftService, linkService, $uibModalInstance) {
        var vm = this,
            seatName = formSeatMap.cabins[cabinIndex].seats[index].headerSeatName,
            letter = name.substr(0, 1);

        vm.indexSeat = index;
        vm.categoryClass = formSeatMap.cabins[cabinIndex].category;
        vm.flagLetter = false;
        vm.flagNumberSeat = false;
        vm.seatModelAircraftSelect = null;
        vm.seatProperties = seatProperties;
        vm.seatPropertiesCheckBox = {};
        vm.seatPropertyIds = [];
        vm.linkService = linkService;
        vm.cabin = formSeatMap.cabins[cabinIndex];
        vm.seat = formSeatMap.cabins[cabinIndex].seats[index];
        vm.seat.seatPropertyId = arrayIntegerToString(vm.seat.seatPropertyId);
        vm.seatPropertyIds = vm.seat.seatPropertyId;
        vm.seatsModelAircraft = seatModelAircraftService.getSeatsModelAircraftByCategory(seatModelAircrafts, false, vm.categoryClass);
        vm.isDisabledStyle = false;

        getSeatPropertiesCheckBox();

        vm.formHeaderSeat = {
            'seatName': vm.seat.headerSeatName,
            'seatNumber': vm.seat.number,
            'aisle': false,
            'flagLetter': vm.flagLetter,
            'flagNumberSeat': vm.flagNumberSeat
        }

        vm.changeLetter = function () {
            vm.formHeaderSeat.flagLetter = true;
        }

        vm.changeNumberSeat = function () {
            vm.formHeaderSeat.flagNumberSeat = true;
        }

        vm.saveHeaderSeatName = function (isValid, formHeaderSeat) {
            if (isValid) {
                if (vm.seatModelAircraftSelect != null) {
                    vm.seat.seatModelAircraftId = vm.seatModelAircraftSelect.seatModelAircraftId;
                    vm.seat.urlImage = vm.seatModelAircraftSelect.url;
                }
                $uibModalInstance.close({
                    form: formHeaderSeat,
                    seatPropertyIds: vm.seatPropertyIds,
                    isSeatDefault: vm.isSeatDefault
                });
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.addSeatProperty = function (seatProperty, seatPropertyId) {
            if (vm.seatPropertiesCheckBox[seatPropertyId] === true) {
                vm.seatPropertyIds.push(seatPropertyId);
            } else if (vm.seatPropertiesCheckBox[seatPropertyId] === false || vm.seatPropertiesCheckBox[seatPropertyId] === undefined) {
                vm.seatPropertyIds.splice(vm.seatPropertyIds.indexOf(seatPropertyId), 1);
            }

            if(vm.seatPropertyIds.length === 0) {
                vm.isDisabledStyle = false;
            } else {
                vm.isDisabledStyle = true;
            }
        }

        vm.onSelectCustomSeat = function (event, seatModelAircraft) {
            vm.seatModelAircraftSelect = seatModelAircraft;
            $('.image-custom-seat').removeClass('active');
            $(event.target).addClass('active');
        }

        function getSeatPropertiesCheckBox() {
            angular.forEach(vm.seatProperties, function (seatProperty) {
                vm.seatPropertiesCheckBox[linkService.getLinkId(seatProperty._links.self.href)] = false;
            });

            angular.forEach(vm.seat.seatPropertyId, function (id) {
                vm.seatPropertiesCheckBox[id] = true;
            });
        }
    }

    function deleteCabinSeatController(index, cabinIndex, formSeatMap, $uibModalInstance) {
        var vm = this;
        vm.seatNumber = formSeatMap.cabins[cabinIndex].seats[index].number;

        vm.deleteSeat = function () {
            $uibModalInstance.close(true);
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function deleteStructureSeatMapController(structureId, structure, structureSeatMapService, $uibModalInstance) {
        var vm = this;
        vm.name = structure.data.name;

        vm.deleteStructureSeatMap = function () {
            structureSeatMapService.deleteStructure(structureId)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function addColumns(cabins, vm) {
        vm.formSeatMap.columns = [];
        vm.formSeatMap.rows = [];
        vm.formSeatMap.heights = [];
        vm.formSeatMap.widths = [];
        vm.formSeatMap.widthTotal = 0;
        vm.formSeatMap.detailRows = [];

        angular.forEach(cabins, function (cabin) {
            var columns = cabin.column;
            var rows = cabin.row;
            vm.formSeatMap.columns.push(columns);
            vm.formSeatMap.rows.push(rows);
            vm.formSeatMap.detailRows.push({category: cabin.category, row: rows, width: cabin.width, height: cabin.height});
            vm.formSeatMap.widths.push(cabin.width);
            vm.formSeatMap.heights.push(cabin.height);
            vm.formSeatMap.widthTotal = vm.formSeatMap.widthTotal + cabin.width;
        });

        /*var maxRow = calculateColumnMax(vm.formSeatMap.rows);
        var imageHead = 'imageHead' + maxRow;
        var imageTail = 'imageTail' + maxRow;*/
        var maxDetailRow = calculateDetailRowMax(vm.formSeatMap.detailRows, 2);
        var imageHead = 'imageHead' + maxDetailRow.row + '' + maxDetailRow.category;
        var imageTail = 'imageTail' + maxDetailRow.row + '' + maxDetailRow.category;
        var widthHead = widthHeadImage(imageHead);
        var widthTail = widthTailImage(imageTail);

        vm.formSeatMap.widthTotal = vm.formSeatMap.widthTotal + widthHead + widthTail + 10;
    }

    function changeCabinView(cabins, cabinIndex, vm) {
        angular.forEach(cabins, function (cabins, index) {
            if (cabinIndex === index) {
                vm.formSeatMap.cabins[index].view = true;
            } else {
                vm.formSeatMap.cabins[index].view = false;
            }
        })
    }

    function calculateTotalPixels(pixels, type) {
        var res = 0,
            aux = (type === 'height') ? 10 : 0;
        angular.forEach(pixels, function (pixel) {
            res = res + pixel + aux;
        });
        return res;
    }

    function calculateColumnMax(columns) {
        var res = 0;
        if (columns.length > 1) {
            for (var i = 0; i < columns.length; i++) {
                if (columns[i] > res) {
                    res = columns[i];
                }
            }
        } else {
            res = columns[0];
        }
        return res;
    }

    function calculateDetailRowMax(detailRows, type) {
        var res = 0;
        var auxDetailRow = null;
        if (detailRows.length > 1) {
            for (var i = 0; i < detailRows.length; i++) {
                var detailRow = detailRows[i];
                if (detailRow.height > res) {
                    res = detailRow.height;
                    auxDetailRow = detailRow;
                } else if (detailRow.height === res) {
                    if (detailRow.row > auxDetailRow.row) {
                        res = detailRow.height;
                        auxDetailRow = detailRow;
                    } else if (auxDetailRow.row > detailRow.row){
                        res = auxDetailRow.height;
                        //auxDetailRow = auxDetailRow;
                    } else {
                        res = detailRow.height;
                        auxDetailRow = detailRow;
                    }
                }
            }
        } else {
            res = detailRows[0].height;
            auxDetailRow = detailRows[0];
        }

        if(type === 1) {
            return (auxDetailRow != null) ? auxDetailRow.row + '-' + auxDetailRow.category : "";
        }else {
            return auxDetailRow;
        }
    }

    function calculateNumMax(numbers) {
        var res = 0;
        for (var i = 0; i < numbers.length; i++) {
            if (numbers[i] > res) {
                res = numbers[i];
            }
        }
        return res;
    }

    function calculateHeightMax(detailRows) {
        var res = 0;
        for (var i = 0; i < detailRows.length; i++) {
            var detailRow = detailRows[i]
            if (detailRow.height > res) {
                res = detailRow.height;
            }
        }
        return res;
    }

    function widthHeadImage(imageHead) {
        var headImage = {
            'imageHead2Y': 118,
            'imageHead3Y': 169,
            'imageHead4Y': 218,
            'imageHead5Y': 269,
            'imageHead6Y': 318,
            'imageHead7Y': 371,
            'imageHead8Y': 420,
            'imageHead9Y': 473,
            'imageHead10Y': 524,
            'imageHead11Y': 574,
            'imageHead12Y': 624,
            'imageHead2C': 118,
            'imageHead3C': 168,
            'imageHead4C': 218,
            'imageHead5C': 269,
            'imageHead6C': 318,
            'imageHead7C': 371,
            'imageHead8C': 420,
            'imageHead9C': 473,
            'imageHead10C': 524,
            'imageHead11C': 574,
            'imageHead12C': 624,
            'imageHead2F': 118,
            'imageHead3F': 203,
            'imageHead4F': 265,
            'imageHead5F': 330,
            'imageHead6F': 394,
            'imageHead7F': 457,
            'imageHead8F': 519,
            'imageHead9F': 583,
            'imageHead10F': 645,
            'imageHead11F': 707,
            'imageHead12F': 772
        };

        return headImage[imageHead];
    }

    function widthTailImage(imageTail) {
        var tailImage = {
            'imageTail2Y': 120,
            'imageTail3Y': 173,
            'imageTail4Y': 224,
            'imageTail5Y': 274,
            'imageTail6Y': 328,
            'imageTail7Y': 380,
            'imageTail8Y': 433,
            'imageTail9Y': 486,
            'imageTail10Y': 537,
            'imageTail11Y': 588,
            'imageTail12Y': 640,
            'imageTail2C': 120,
            'imageTail3C': 173,
            'imageTail4C': 224,
            'imageTail5C': 274,
            'imageTail6C': 328,
            'imageTail7C': 380,
            'imageTail8C': 433,
            'imageTail9C': 486,
            'imageTail10C': 537,
            'imageTail11C': 588,
            'imageTail12C': 640,
            'imageTail2F': 120,
            'imageTail3F': 209,
            'imageTail4F': 273,
            'imageTail5F': 338,
            'imageTail6F': 404,
            'imageTail7F': 468,
            'imageTail8F': 533,
            'imageTail9F': 598,
            'imageTail10F': 663,
            'imageTail11F': 727,
            'imageTail12F': 791
        }

        return tailImage[imageTail];
    }

    function arrayStringToInteger(data) {
        return data.map(function (item) {
            return parseInt(item, 10);
        });
    }

    function arrayIntegerToString(data) {
        return data.map(String);
    }

})();

